exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-572921dd]{font-weight:200;color:#fff;font-size:4.5vmax}img.flags[data-v-572921dd]{width:100%;max-width:450px}@media screen and (max-width:560px){h1[data-v-572921dd]{font-size:7vw}}", ""]);

// exports
